import { Link as LinkIcon } from 'lucide-react';
import TreasuryAccountsManager from './TreasuryAccountsManager';

export default function BankTab() {

  return (
    <div className="space-y-8">
      {/* Section principale : Comptes de trésorerie */}
      <TreasuryAccountsManager />

      {/* Section optionnelle : Agrégation bancaire */}
      <div className="border-t pt-8">
        <div className="mb-6">
          <div className="flex items-center gap-3 text-gray-400 cursor-not-allowed opacity-60">
            <div className="p-2 bg-gray-100 rounded-lg">
              <LinkIcon className="h-5 w-5" />
            </div>
            <div className="text-left">
              <h3 className="font-semibold">Agrégation bancaire (optionnel)</h3>
              <p className="text-sm text-gray-500">
                Synchronisez automatiquement vos comptes bancaires
              </p>
            </div>
          </div>
        </div>

        <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
          <p className="text-sm text-orange-800 font-medium">
            En cours de développement
          </p>
          <p className="text-sm text-orange-700 mt-1">
            Cette fonctionnalité sera disponible prochainement.
          </p>
        </div>
      </div>
    </div>
  );
}
